import { TriggerKey } from '@/constants';
import HomePageContainer from '@/containers/homepage-v2';
import { CarouselModule } from '@/containers/homepage-v2/carousel-module';
import { useFeelgood } from '@/libs/useFeelgood';
import React from 'react';
import { Framework } from '../layouts';
import { Banner } from './Banner';
import { Tabs } from './Tabs';

const Homepage = () => {
  useFeelgood(TriggerKey.Homepage);
  return (
    <Framework enableDarkHeader={true} hideFooter={false}>
      <div className="mt-[-60px]">
        <Banner />
        <CarouselModule className="flex justify-center mt-40" />
        <Tabs />
        <HomePageContainer />
      </div>
    </Framework>
  );
};

export default Homepage;
